// Service to convert DOC files via server API

interface ParseDocResponse {
  text: string
}

interface ParseDocError {
  error?: string
}

export async function parseDocServer(file: File): Promise<string> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch('/api/parse-doc', {
    method: 'POST',
    body: formData,
  })

  if (!response.ok) {
    const errorData = (await response
      .json()
      .catch(() => ({ error: 'Failed to parse document' }))) as ParseDocError
    throw new Error(errorData.error || 'Failed to parse document')
  }

  const result: ParseDocResponse = await response.json()
  return result.text
}
